import Cookies from 'js-cookie'

type CookieAttributes = Parameters<typeof Cookies.set>[2]

export function getCookie(cookieKey: string): string | undefined {
  return Cookies.get(cookieKey)
}

export function setCookie(
  cookieKey: string,
  cookieValue: string,
  params?: CookieAttributes
): string | undefined {
  return Cookies.set(cookieKey, cookieValue, params)
}

export function removeCookie(cookieKey: string): void {
  Cookies.remove(cookieKey)
}
